// extracted by mini-css-extract-plugin
module.exports = {"table_filters_panel":"_table-filters-panel_table_filters_panel__tySav"};